import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatNumberWithCommas(value: string): string {
    // Remove any existing commas and non-digit characters
    const number = value.replace(/[^\d]/g, '');

    // Add commas for thousands
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function ensureTrailingSlash(value?: string): string {
    if (!value) return '';

    if (value.endsWith('/')) return value;
    return `${value}/`;
}

export function stripTrailingSlash(value: string) {
    return value.replace(/\/+$/, '');
}

export function stripMarkdownChatTag<T extends string | null | undefined>(
    input: T,
): T extends string ? string : T {
    if (!input) return input as T extends string ? string : T;
    let result = input.trim();
    // TODO : /^```\w+\n?/,  // Matches ```javascript, ```typescript, etc.
    if (result.startsWith('```markdown')) result = result.substring(11);
    if (result.startsWith('```')) result = result.substring(3);
    if (result.endsWith('```')) result = result.substring(0, result.length - 4);

    return result.trim() as T extends string ? string : T;
}

export function asArr<T>(input: T | T[]): T[] {
    if (Array.isArray(input)) return input;
    return [input];
}
export { asArr as arrayOf, asArr as arrOf };
